var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.2578 6.50222L6.58154 11.9107H0.570312L5.2503 6.50222L0.570312 1.09375H6.57779L11.2578 6.50222Z",
    fill: "url(#paint0_linear_5216_92244)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25497 6.50182L3.63749 13H0L5.62498 6.50182L0 0H3.63374L9.25497 6.50182Z",
    fill: "url(#paint1_linear_5216_92244)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5216_92244",
    x1: 5.14427,
    y1: 5.50037,
    x2: 8.81591,
    y2: 6.55654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5216_92244",
    x1: 3.60129,
    y1: 6,
    x2: 7.71333,
    y2: 6.52888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7540"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowmark);
export default __webpack_public_path__ + "static/media/arrowmark.880d2b74d8c322b4b47c83b2bd86d567.svg";
export { ForwardRef as ReactComponent };